import React from 'react'
import classNames from 'classnames'

/** Matches NewTrustMarkersWrapper shell; min-height only on loading for CLS. */
export const trustMarkersPlaceholderClassName = ({
  useGridLayout,
  hasLogosGroup,
}) =>
  classNames(
    hasLogosGroup ? 'px-0' : 'px-6',
    'pt-8 pb-2 lg:pt-12 lg:pb-6',
    useGridLayout ? 'min-h-112 lg:min-h-44' : 'min-h-48'
  )

const TrustMarkersPlaceholder = ({
  useGridLayout,
  logosGroupCount = 0,
  showDesktopTitle = false,
  hasLogosGroup = false,
}) => (
  <div
    className={trustMarkersPlaceholderClassName({
      useGridLayout,
      hasLogosGroup,
    })}
    aria-busy="true"
    aria-hidden="true"
    data-testid="trust-markers-placeholder"
  >
    {showDesktopTitle && (
      <div className="mx-auto mb-2 h-6 max-w-md animate-pulse rounded bg-gray-200 lg:max-w-lg" />
    )}
    <div className="px-4 lg:px-0">
      {useGridLayout ? (
        <>
          <div className="flex flex-col lg:h-24 lg:flex-row lg:items-center lg:justify-center">
            {[0, 1, 2, 3].map((key) => (
              <div
                key={key}
                className="flex w-full items-center justify-center border-b border-gray-200 py-6 last:border-b-0 lg:h-24 lg:w-fit lg:border-r lg:border-b-0 lg:px-2 lg:py-0 lg:last:border-r-0"
              >
                <div className="h-20 w-36 animate-pulse rounded bg-gray-200" />
              </div>
            ))}
          </div>
          {logosGroupCount > 0 && (
            <div className="flex flex-col lg:ml-4 lg:flex-row lg:items-center">
              {Array.from({ length: logosGroupCount }).map((_, key) => (
                <div
                  key={key}
                  className="flex w-full items-center justify-center border-b border-gray-200 py-6 last:border-b-0 lg:h-24 lg:border-r lg:border-b-0 lg:py-0 lg:last:border-r-0"
                >
                  <div className="h-12 w-28 animate-pulse rounded bg-gray-200" />
                </div>
              ))}
            </div>
          )}
        </>
      ) : (
        <div className="h-24 w-full animate-pulse rounded bg-gray-200" />
      )}
    </div>
  </div>
)

export default TrustMarkersPlaceholder
